var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {}, _obj[_vm.$style['document-link']] = true, _obj[_vm.$style['document-link_inverted']] = _vm.inverted, _obj ),on:{"click":function($event){$event.stopPropagation();return _vm.onClick.apply(null, arguments)}}},[_c('SwLink',{class:_vm.$style['document-link__sw-link'],attrs:{"inverted":_vm.inverted,"black":""}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }